import {
  PLAID_LINK_TOKEN_DESER,
  PlaidLinkToken,
  type AchRelationship,
  type PLATFORM_NAMES,
} from "../../tastyworks/cash-management"
import type HttpClient from "../../tastyworks/http"
import {
  BaseResponse,
  parseErrorContainer,
  type SingleResponse,
} from "../../tastyworks/response"

const ACH_LINK_API_VERSION = "20260430"
const ACH_LINK_API_HEADERS: HeadersInit = {
  "Accept-Version": ACH_LINK_API_VERSION,
}

export class AchLinkTokenService {
  constructor(
    private readonly customerMeClient: HttpClient,
    private readonly accountNumberClient: HttpClient
  ) {}

  readonly create = async (
    platform: PLATFORM_NAMES,
    redirectUri: string
  ): Promise<SingleResponse<PlaidLinkToken>> => {
    const plaidLinkToken = new PlaidLinkToken()
    plaidLinkToken.redirectUri = redirectUri

    return this.customerMeClient.create(
      plaidLinkToken,
      PLAID_LINK_TOKEN_DESER.serialize,
      PLAID_LINK_TOKEN_DESER.update,
      "ach-link-token",
      {
        "platform-name": platform,
      },
      ACH_LINK_API_HEADERS
    )
  }

  readonly updateToken = async (
    platform: PLATFORM_NAMES,
    achRelationship: AchRelationship
  ): Promise<SingleResponse<PlaidLinkToken>> =>
    this.accountNumberClient.create(
      new PlaidLinkToken(),
      PLAID_LINK_TOKEN_DESER.serialize,
      PLAID_LINK_TOKEN_DESER.update,
      "external-institutions/:id/link-token",
      {
        "platform-name": platform,
        id: achRelationship.externalInstitution?.id,
        accountNumber: achRelationship.accountNumber,
      }
    )

  /**
   * Reauthenticate external institution (after updating expired credentials via Plaid)
   *
   * @param platform
   * @param achRelationship
   * @param depositId optional, if provided, deposit is reverified and granted instant buying power if possible
   */
  readonly authenticate = async (
    platform: PLATFORM_NAMES,
    achRelationship: AchRelationship,
    depositId?: string
  ) => {
    let helper = await this.accountNumberClient.postJson(
      "external-institutions/:id/authenticate",
      {
        "deposit-id": depositId,
      },
      {
        "platform-name": platform,
        id: achRelationship.externalInstitution?.id,
        accountNumber: achRelationship.accountNumber,
      }
    )
    const response = new BaseResponse()
    parseErrorContainer(helper, response)
    return response
  }
}
